import React, { memo } from 'react';
import {
    Paper,
    Typography,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Box,
    Chip,
    Checkbox,
    ListItemText,
    Button,
} from '@mui/material';

const AssignmentUpdateBox = ({
    hasSelection,
    selectionCount,
    action,
    role,
    assignUsers,
    users,
    onActionChange,
    onRoleChange,
    onAssignUsersChange,
    onSubmit,
}) => {
    if (!hasSelection) return null;

    return (
        <Paper
            elevation={6}
            sx={{
                mt: 2,
                px: 2,
                py: 1.5,
                borderRadius: '16px 16px 0 0',
                bgcolor: 'background.paper',
                position: 'sticky',
                bottom: 0,
                zIndex: (theme) => theme.zIndex.appBar - 1,
                borderTop: 1,
                borderColor: 'divider',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1.5,
                }}
            >
                <Typography variant="subtitle1" fontWeight={600}>
                    Update Assignment
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {selectionCount} tracker{selectionCount > 1 ? 's' : ''} selected
                </Typography>
            </Box>

            <Grid container spacing={2}>
                {/* Action select */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Action</InputLabel>
                        <Select
                            value={action}
                            onChange={(e) => onActionChange(e.target.value)}
                            label="Action"
                        >
                            <MenuItem value="Assign">Assign</MenuItem>
                            <MenuItem value="Unassign">Unassign</MenuItem>
                            <MenuItem value="Reassign">Reassign</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* Role select */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Role</InputLabel>
                        <Select
                            value={role}
                            onChange={(e) => onRoleChange(e.target.value)}
                            label="Role"
                        >
                            <MenuItem value="Owner">Owner</MenuItem>
                            <MenuItem value="Manager">Manager</MenuItem>
                            <MenuItem value="Reviewer">Reviewer</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* Users multi-select */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Users</InputLabel>
                        <Select
                            multiple
                            value={assignUsers}
                            onChange={(e) => {
                                const { value } = e.target;
                                onAssignUsersChange(
                                    typeof value === 'string' ? value.split(',') : value
                                );
                            }}
                            input={<OutlinedInput label="Users" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((val) => (
                                        <Chip key={val} label={val} size="small" />
                                    ))}
                                </Box>
                            )}
                        >
                            {users.map((usr) => (
                                <MenuItem key={usr} value={usr}>
                                    <Checkbox checked={assignUsers.indexOf(usr) > -1} />
                                    <ListItemText primary={usr} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            {/* Submit button */}
            <Box
                sx={{
                    mt: 1.5,
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={onSubmit}
                >
                    Submit
                </Button>
            </Box>
        </Paper>
    );
};

export default memo(AssignmentUpdateBox);
